<script setup lang="ts">
import axios from 'axios';
import { useRoute } from 'vue-router';

const route = useRoute();

const props = defineProps<{
    reviewLink: string;
    reviewTarget: string;
}>();
import { Button } from '@/components/ui/button';

function openReviewLink() {
    axios.post('/setSatisfaction', {
        appID: route.query.appID,
        target: props.reviewTarget,
    });
}
</script>

<template>
    <div>
        <div class="font-extrabold text-[28px] text-gray-900">Support Us with a Google Review</div>
        <div class="font-medium text-lg text-gray-900 mt-2">Your support helps us reach more wonderful patients like you and continuously improve.</div>
        <Button as-child size="lg" class="mt-10 w-full" @click="openReviewLink">
            <a :href="reviewLink" target="_blank">Leave a Google Review</a>
        </Button>
    </div>
</template>
